import { createSlice } from '@reduxjs/toolkit'
import {
    dismissMarkerNotificationThunk,
    fetchMarkerNotifications,
} from '../thunks/markerNotificationThunks'
import type { MarkerNotification } from '../../types/markerNotification.types'

interface MarkerNotificationsState {
    items: MarkerNotification[]
    totalCount: number
    importantCount: number
    loading: boolean
    error: string | null
}

const initialState: MarkerNotificationsState = {
    items: [],
    totalCount: 0,
    importantCount: 0,
    loading: false,
    error: null,
}

const markerNotificationsSlice = createSlice({
    name: 'markerNotifications',
    initialState,
    reducers: {
        removeNotificationById: (state, action: { payload: number }) => {
            const id = action.payload
            const removed = state.items.find(item => item.id === id)
            state.items = state.items.filter(item => item.id !== id)
            if (removed) {
                state.totalCount = Math.max(0, state.totalCount - 1)
                if (removed.priority === 'IMPORTANT') {
                    state.importantCount = Math.max(0, state.importantCount - 1)
                }
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMarkerNotifications.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchMarkerNotifications.fulfilled, (state, action) => {
                state.loading = false
                state.items = action.payload.items
                state.totalCount = action.payload.totalCount
                state.importantCount = action.payload.importantCount
            })
            .addCase(fetchMarkerNotifications.rejected, (state, action) => {
                state.loading = false
                state.error = (action.payload as string) ?? 'Failed to load notifications'
            })
            .addCase(dismissMarkerNotificationThunk.fulfilled, (state, action) => {
                const id = action.payload
                const removed = state.items.find(item => item.id === id)
                state.items = state.items.filter(item => item.id !== id)
                if (removed) {
                    state.totalCount = Math.max(0, state.totalCount - 1)
                    if (removed.priority === 'IMPORTANT') {
                        state.importantCount = Math.max(0, state.importantCount - 1)
                    }
                }
            })
    },
})

export const { removeNotificationById } = markerNotificationsSlice.actions
export default markerNotificationsSlice.reducer
